export const homeConstants = {
  FETCH_BANNERS_START: 'FETCH_BANNERS_START',
  FETCH_BANNERS_SUCCESS: 'FETCH_BANNERS_SUCCESS',
  FETCH_BANNERS_FAILURE: 'FETCH_BANNERS_FAILURE',

  FETCH_HIGHLIGHT_FUNDS_START: 'FETCH_HIGHLIGHT_FUNDS_START',
  FETCH_HIGHLIGHT_FUNDS_SUCCESS: 'FETCH_HIGHLIGHT_FUNDS_SUCCESS',
  FETCH_HIGHLIGHT_FUNDS_FAILURE: 'FETCH_HIGHLIGHT_FUNDS_FAILURE',

  UPDATE_NAV_FUNDS: 'UPDATE_NAV_FUNDS',

  FETCH_NAV_FUNDS_START: 'FETCH_NAV_FUNDS_START',
  FETCH_NAV_FUNDS_SUCCESS: 'FETCH_NAV_FUNDS_SUCCESS',
  FETCH_NAV_FUNDS_FAILURE: 'FETCH_NAV_FUNDS_FAILURE',

  FETCH_TOP_SUB_CATEGORIES_START: 'FETCH_TOP_SUB_CATEGORIES_START',
  FETCH_TOP_SUB_CATEGORIES_SUCCESS: 'FETCH_TOP_SUB_CATEGORIES_SUCCESS',
  FETCH_TOP_SUB_CATEGORIES_FAILURE: 'FETCH_TOP_SUB_CATEGORIES_FAILURE',

  FETCH_ARTICLES_START: 'FETCH_ARTICLES_START',
  FETCH_ARTICLES_SUCCESS: 'FETCH_ARTICLES_SUCCESS',
  FETCH_ARTICLES_FAILURE: 'FETCH_ARTICLES_FAILURE',

  TOGGLE_ARTICLE_MODAL: 'TOGGLE_ARTICLE_MODAL'
};